
import React,{useEffect, useState, useRef, ReactNode} from 'react';
import { useDays } from '../../context/DaysContext';
import "./Stats.css"
import { getLastMonday, getNormalizedPercentage } from '../../utils';
import dayController, { TGoalDays, TStat } from '../../controllers/days';
import {  TDay, TDayGoal, TProgress, TStats } from '../../controllers/days';
import { TUser, useUser } from '../../context/AuthContext';
import { editGoalAmount, TGoal, TGoalForm } from '../../controllers/goals';
import { formatDate, getAmountString, getGoalAmountString,  SingleGoal, sumDayProgress, sumDaysProgress, } from '../Goals/Goals';
import AddProgress from '../../components/AddProgress';
import EditProgress from '../../components/EditProgress';
import EditGoal from '../../components/EditGoal';
import Input from '../../components/Input/Input';
import { usePop } from '../../context/PopContext';
import ProgressDays from '../Goals/ProgressDays';
import PointPop from './PointPop/PointPop';
import GraphSkeleton from './GraphSkeleton/GraphSkeleton';
import { useStatsV2 } from '../../context/StatsContextV2';
import UserPointPop from './PointPop/UserPointPop';
type TPoint = {
    x: number,
    y: number
}

export type TGraphPoint = {
    id: string,
    amountHeight: number,
    progress: number,
    color: string,
    date: Date,
    gradientId: string,
    history: TDay[],
    goal: TGoal
} & TPoint;
type TDayPoint =TDay & {

}
type TMonthPoint = {
    id: string,
    name: string
} &TPoint;
// const gap = 25;
// const padding = 10;
const gap = 25;
const rectWidth =gap/2;
const paddingVertical = 10;
const paddingHorizontal = 40;
const minSvgWidth = 0;

export const getPercentage = (amount: number, progress: number) =>{
    let percentage = Math.round(100/(amount)* progress);
    //percentage = percentage > 100 ? 100 : percentage;
    return percentage;
}
export const normalizePercentage = (percentage: number) =>{
    percentage = percentage > 100 ? 100 : percentage;
    return percentage
}
export const getProgressColor = (percentage: number) =>{
    if(percentage > 100) percentage = 100;
    return `rgb(${185-percentage}, ${Math.round(200/100 * percentage)}, ${ Math.round(82/100 * percentage)})`;
}
function getCalendarDates(from: number, to: number, option?: "daily" | "weekly"){
    let startDate = new Date(from);
    const endDate = new Date(to);
    startDate.setHours(0,0,0,0);
    endDate.setHours(0,0,0,0);
    const dateArrays = [];
    if(!option || option === "daily"){
        for(; startDate <= endDate; startDate.setDate(startDate.getDate() + 1)){
            dateArrays.push(new Date(startDate));
        }
    }else if(option === "weekly"){
        startDate = getLastMonday(startDate);
        for(; startDate <= endDate; startDate.setDate(startDate.getDate() + 7)){
            dateArrays.push(new Date(startDate));
        }
    }
    
    //dateArrays.push(new Date(startDate));
    // //-- console.log(dateArrays);
    return dateArrays;
}
function createPolygonStringAndMonthPoints (graph: TGraphPoint[]) {
    let str = "";
    let monthPointsArray:TMonthPoint[]= [];
    for(let i = 0; i < graph.length; i++){
        let point = graph[i];
        str += `${point.x},${point.y} `;
        let day = new Date(graph[i].date);
        let previousDay = new Date(graph[i-1]?.date);
        if(day.getMonth() != previousDay.getMonth() ){
            monthPointsArray.push({...point, name: point.date.toLocaleString('en-us', { month: 'long' }), id: "month" + point.date.getTime()});
        }
    }
    str+=`${graph[graph.length-1].x},150 ${graph[0].x},150`;
    return {
        monthPoints: monthPointsArray,
        polygonString: str
    }
}

export function createGraphPoint(goal: TGoal, history: TDay[], date: Date, i: number, frequency: TGoal["frequency"], maxAmount?: number, ): TGraphPoint{
    if(!maxAmount)  maxAmount  = 0;

    let goalProgress = sumDaysProgress(history)

    let progressHeight = getPercentage(maxAmount, goalProgress);
    
    //let maxAmount = (100 *sumDaysProgress(newHistory))/  (150 - point.amountHeight);
    let progressPercentage = normalizePercentage(getPercentage(goal.amount, goalProgress));
    let amountHeight = getPercentage(maxAmount, goal.amount);
    ////-- console.log({amountHeight, maxAmount, amount: goal.amount})
    let color = getProgressColor(progressPercentage)
    //let dayNumber = date.getDate().toString()
    let id = goal._id + date.getTime();
    let gradientId = "gradient" +  id;
    
    return {
        id,
        progress: progressHeight,
        date: date,
        color,
        gradientId,
        history,
        goal: {
            ...goal,
            frequency
        },
        x: i * gap + paddingHorizontal,
        y: 150 - progressHeight,
        amountHeight: 150 - amountHeight
        //Oppure 150 - progress + padding???
    }

}
type TDateDays = {
    date: Date, 
    days: TDay[]
}
export function getDaysArray(frequency: TGoal["frequency"], calendar: Date[], stats: TDay[]):TDateDays[]{
    let daysArray: TDateDays[] = [];
    let j = 0;
    calendar.map((date, i) =>{
        let day = stats[j];
        //if(!day) return daysArray.push({date, days: []});
        if(frequency=== "weekly"){
            if(day) {
                let history = [];
                while(stats[j ]&& date.getTime()  + 7 * 24 *60 * 60 * 1000 > stats[j].date.getTime()){
                    day = stats[j]
                    history.push(day)
                    j++;
                    
                }
                daysArray.push({date, days: history})
            } else daysArray.push({date, days: []})
        }else if(frequency === "daily"){
            // //-- console.log()
           // //-- console.log(day, date.toDateString(), new Date(day.date).toDateString(), j)
            if(day&& date.toDateString() === new Date(day.date).toDateString()){
                daysArray.push({date, days: [day]})
                j++;
            }else daysArray.push({date, days: []})
            // //-- console.log( j)
        }
    })
    return daysArray;
}
const getHigherGoalAmount = (progresses: TProgress[]) =>{
    let max = 0;
    for (let i = 0; i < progresses.length; i++) {
        const p =progresses[i];
        if(p.goalAmount > max) max = p.goalAmount;
    }
    return max;
}
export function getMaxProgress(stats: TDateDays[], frequency: TGoalForm["frequency"]){
    // Da rivedere
    let maxAmount = 0;

        for(const {days, date} of stats){
            
            for (let i = 0; i < days.length; i++) {
                const day = days[i];
                 const curAmount = sumDayProgress(day.progresses);
                 const higherAmount = getHigherGoalAmount(day.progresses)
                //const latestDay = days[days.length-1];
                //if(latestDay && latestDay.goal.amount > maxAmount) maxAmount = latestDay.goal.amount;
                if(curAmount > maxAmount) maxAmount = curAmount;
                if(higherAmount > maxAmount) maxAmount = higherAmount;
            }
          
        }

    

    return maxAmount;
}
export function createEmptyPoint(goal: TGoal, date: Date, i: number, frequency: TGoal["frequency"],  maxAmount: number ) {
    let id = goal._id + date.getTime();
    let point: TGraphPoint =  {
        id,
        color: getProgressColor(0), 
        date: date, 
        gradientId: "gradient" + id, 
        progress: 0,
        x: i *gap +paddingHorizontal,
        y:  150, 
        history: [], 
        goal: {
            ...goal,
            frequency
        }, 
        amountHeight: 150- getPercentage(maxAmount, goal.amount)
        };
    return point;
}
export type TPointDays = {[key: number] : TGraphPoint};
export function createGraphArray(stats: TDay[], goal: TGoal):TPointDays {
    if(stats.length < 1) return [];
   // //-- console.log("HELLO GRAPH ARRAY")
    let firstDay = stats[0];
    let graphsArray:TGraphPoint[] = [];
    
    let today = new Date();//new Date("2024, 12, 25")
    
    let option: "daily" | "weekly" = goal.frequency === "daily"? "daily" : "weekly";
    let calendar = getCalendarDates(firstDay.date.getTime(), today.getTime(),option );
    // //-- console.log({calendar})
    
    let daysArray: TDateDays[] = getDaysArray(goal.frequency, calendar, stats);
     // //-- console.log({daysArray})
    let maxProgress = getMaxProgress(daysArray, goal.frequency);
    // empty days use latest goal amount
    let dayLatestGoalAmount=  daysArray[0].days[daysArray[0].days.length-1].progresses[0].goalAmount;
    // //-- console.log(goal.title, {maxProgress})
    let result: TPointDays = {};
    daysArray.map(({date, days}, i) =>{
        let point: TGraphPoint;
        ////-- console.log({dayLatestGoalAmount})
        if(days.length > 0 && days[0].progresses.length > 0){
            dayLatestGoalAmount = days[0].progresses[0].goalAmount;
        }
        let dayLatestGoal: TGoal = {...goal, amount: dayLatestGoalAmount};
       //dayLatestGoal = goal;
        if(days.length > 0){
            //dayLatestGoal = days[days.length-1].goal;
            point = createGraphPoint(dayLatestGoal, days, date, i,goal.frequency, maxProgress);
            
        }else point = createEmptyPoint(dayLatestGoal, date, i, goal.frequency, maxProgress)
        result[date.getTime()] = point;
        graphsArray.push(point)
    })
    ////-- console.log("idiot")
    ////-- console.log({result})
    return result
}
export function EditGoalAmount({goal, date}: {goal: TGoal, date: number}){
    const user = useUser();
    const {updateStats} = useStatsV2();
    const {closePop} = usePop();
    const [amount, setAmount] = useState<number>(goal.amount);
    const createGoal = () =>{
        if(!amount) return;
       editGoalAmount({
            title: goal.title,
            userId: user._id,
            frequency: goal.frequency,
            amount,
            progress: 0,
            _id: goal._id
        },date ).then((res) =>{
            closePop();
            updateStats(res)
        }).catch(err=>{
             //-- console.log("error edit amount stats")
        })
    }
    
    return (
    <div className='form'>
        <h2>Edit Goal Amount</h2>
        {goal.type === "time"? <Input.TimePicker onSelect={setAmount} initialValue={goal.amount}/> 
        : goal.type=== "distance"? <Input.DistancePicker onSelect={setAmount} initialValue={goal.amount}/> 
        : <input placeholder='amount' type='number' onChange={(e)=> setAmount(parseInt(e.target.value))} value={amount || ""}></input>}
        <button onClick={createGoal}>save</button>
        
    </div>)
}


function Svg ({graph}:{graph: TGraphPoint[]}) {
    const [pointsString, setPointsString] = useState("");
    const [monthNamePoints, setMonthNamePoints] = useState<TMonthPoint[]>([]);
    const [monthDayScroll, setMonthDayScroll] = useState(0);
    const {userId, editStats}= useStatsV2();
     const user = useUser();
    const isMe = userId == user._id;
    const {setPop} = usePop();
    const ref = useRef<HTMLDivElement>(null);
    const svgWidth = (graph.length -1) * gap + paddingHorizontal * 2 < minSvgWidth? minSvgWidth : (graph.length -1) * gap + paddingHorizontal * 2 ;
    let svgHeight = graph[0].goal.frequency == "daily"? 170 + paddingVertical : 150 + paddingVertical;
   //  //-- console.log({svgWidth, length: graph.length, gap})
    useEffect(() =>{
        
        let {polygonString, monthPoints} = createPolygonStringAndMonthPoints(graph)
        setMonthNamePoints(monthPoints);
        setPointsString(polygonString)
        if(ref.current) {
            // //-- console.log({div: ref.current})
            ref.current.scrollLeft = ref.current.scrollWidth
        }
    },[graph])
    return (
        <>
        {/* PROBLEMA!! MESI UNO ATTACCATO ALL'ALTRo */}
         <div className='months'>
            {
                monthNamePoints.map((month, i) =>{
                    let nextMonthPosition = monthNamePoints[i+1]?  monthNamePoints[i+1].x : svgWidth//graph.length *gap+ padding;
                    let visible = monthDayScroll > month.x - (paddingHorizontal + 0.1);
                    let opacity = svgWidth > 140?  (nextMonthPosition - monthDayScroll - paddingHorizontal)/130 : 1;
                    return <p key={month.id}className='month' style={{opacity, display: visible? "block" : "none", paddingLeft: paddingHorizontal}} >{month.name}</p>
                })
            }
        </div>
        <div className='graph' ref={ref} onScroll={(e)=>{
            let scroll = e.currentTarget.scrollLeft;
            if(Math.abs(scroll - monthDayScroll) >0) setMonthDayScroll(scroll)
        }} style={{}}>
            <svg width={svgWidth} height={svgHeight}>
                <polygon points={pointsString} fill='rgba(92, 200, 82, 0.25)'></polygon>
                {graph.map((point, i) =>{
                    let nextPoint = graph[i+1];
                    if(point.date.getTime() === 1765148400000){
                           //-- console.log("POINntt", {point})
                    }
                    // //-- console.log({point})
                    return (

                        <g onClick={() =>{ setPop( isMe?  <PointPop point={point}/>: <UserPointPop point={point} addLikeToStats={editStats} />, point.goal.title)}} key={point.id}>
                        <rect x={point.x - gap/2} width={gap} height={150} fillOpacity={0}></rect>

                        <circle r={3} cx={point.x} cy={point.amountHeight}z={10} fill={"white"} ></circle>
                        {nextPoint && <line x1={point.x} x2={ nextPoint.x} y1={point.amountHeight} y2={nextPoint.amountHeight} style={{stroke:  "rgba(230, 230, 230, 0.5)"}}  ></line>}

                        <line x1={point.x} x2={point.x} y1={50} y2={150}  className='line-vertical'></line>
                        <circle r={5} cx={point.x} cy={point.y}z={10} fill={point.color} key={i} ></circle>

                        
                        <text x={point.x - (4.5 * point.date.getDate().toString().length)} y={40} style={{color: "red"}}>{point.date.getDate().toString() }</text>
                            {nextPoint? 
                            <>
                            <linearGradient id={point.gradientId} >
                                <stop offset="0%" stopColor={point.color}></stop>
                                <stop offset="100%" stopColor={nextPoint.color}></stop>
                            </linearGradient>
                            <line x1={point.x} y1={point.y} x2={nextPoint.x}y2={nextPoint.y} className='line-connect' stroke={point.color == nextPoint.color? nextPoint.color : `url(#${point.gradientId})` }></line>
                            </>
                        : null}
                        {point.goal.frequency== "daily" ?<text  x={point.x - 5} y={170} fontSize={12} >{point.date.toLocaleDateString("en", {weekday: "narrow"})}</text>: null}
                        </g>
                    )
                })}
            {
                monthNamePoints.map(
                    (month) =>(monthDayScroll < month.x - paddingHorizontal && <text key={month.id}className='month'  x={month.x } y={20}>{month.name}</text>)
                )
            }
            </svg>
            
        </div>
        </>
    )
}

export type TGraph = {
    goal: TGoal,
    points: {
        [day: number]: TGraphPoint
    }
}
function GraphV2() {
    const {stats, reloadStats, loading, userId} = useStatsV2();
    const user = useUser();
    let statsLength = Object.keys(stats).length;
    const isMe = userId == user._id;
    return (
        <div className='graphs'>
          
            {loading? <GraphSkeleton graphs={Object.values(stats)}/>: statsLength > 0?
            <>
            
            {Object.entries(stats).map(([key, graph], i)=>{
                //if(i == 0)  //-- console.log("RERENDER")
                let {points, goal} = graph;
              //  //-- console.log({points, goal})
                return (
                    <div key={goal._id} className='graph-container'>
                        <h3>{goal.title}</h3>
                        
                        {Object.keys(points).length > 0? <Svg graph={Object.values(points)} />: <p>no stats</p>}
                    </div>
                )
            })}</>: isMe? <p>No stats yet, create your goals and add your progress!</p>: <p>No stats yet!</p>}
        </div>
    );
}

export default GraphV2;
